import angular from 'angular';
import helloBookPreviewGenerator from './helloBookPreviewGenerator';
import './style.scss';

export default angular
  .module('helloBook.scenes.helloBookPreviewGenerator', [])
  .component('helloBookPreviewGenerator', helloBookPreviewGenerator).name;
